export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Points de vente"])},
        "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifiant"])},
        "business_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raison sociale"])},
        "sales_channel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Canal de vente"])},
        "sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animateur"])},
        "monthly_sales_target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objectif de vente mensuel"])},
        "edit_monthly_sales_target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier l'objectif de vente"])},
        "external_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifiant externe"])},
        "organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réseau"])},
        "ownership_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type d’exploitation"])},
        "shipping_address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse postale"])},
        "ownership_types": {
          "branch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Succursale"])},
          "association": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Association"])},
          "franchisee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Franchise"])},
          "independant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indépendant"])}
        },
        "tab_referent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Référent"])},
        "tab_business_verticals": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Produits d'assurance"])}
      },
      "en": {
        "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Points of sale"])},
        "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifier"])},
        "business_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Business name"])},
        "sales_channel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales channel"])},
        "sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales field manager"])},
        "monthly_sales_target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monthly sales target"])},
        "edit_monthly_sales_target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit the sales target"])},
        "external_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["External identifier"])},
        "organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network"])},
        "ownership_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ownership type"])},
        "shipping_address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postal address"])},
        "ownership_types": {
          "branch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Branch"])},
          "association": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Association"])},
          "franchisee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Franchise"])},
          "independant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Independent"])}
        },
        "tab_referent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Referent"])},
        "tab_business_verticals": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insurance products"])}
      }
    }
  })
}
